import { curry } from 'lodash';
import { MAX_CATEGORY_LABEL_LENGTH } from '@wix/communities-blog-client-common/dist/src/constants/validation';

export const stripNewLines = (value = '') => value.replace(/\n/g, '');
const truncate = curry((maxLength, value = '') => value.slice(0, maxLength));

export const post = {
  title: stripNewLines,
};

export const category = {
  label: stripNewLines,
  description: stripNewLines,
};

export const categoryInline = {
  label: value => truncate(MAX_CATEGORY_LABEL_LENGTH, value),
};
